<template>
  <v-row no-gutters>
    <v-col class="relative" cols="12">
      <template v-if="keywords && keywords.length === 0">
        <div class="no-keywords">
          <img
            src="@/static/analytics/noPeriodicChart.svg"
            alt="No keywords added."
          />
          <p class="no-keywords__description">
            {{ $t("message.analytics.periodic.chart.noKeywordsDescription") }}
          </p>
        </div>
      </template>

      <template v-if="keywords && keywords.length > 0">
        <Chart
          v-if="
            chart &&
              chart.data &&
              chart.data.length > 0 &&
              chart.labels &&
              chart.labels.length > 0
          "
          :height="chartHeight"
          :data="chart.data"
          :labels="chart.labels"
          :loading="loading.chart"
          :max-value-y="maxValueY"
          :selected-report-type="selectedReportType"
          @loadingChartStatus="setLoading"
        />
        <NoData
          class="no-data"
          v-else-if="chart.data.length === 0 || chart.labels.length === 0"
        />
        <div v-else class="no-data" />
      </template>
      <SectionLoader :status="loading.chart" :opacity="0.75" />
    </v-col>
  </v-row>
</template>

<script>
import Chart from "@/components/Analytics/Periodic/Chart.js";
import NoData from "@/components/ui/NoData.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import { gtmEngagement as gtmEngagementMixin } from "@/helpers/mixins/gtm-engagement";
import { PERIODIC_REPORT_TYPE } from "@/enums/charts-type.enum";

export default {
  name: "PeriodicChartTab",
  components: {
    Chart,
    NoData,
    SectionLoader
  },
  mixins: [gtmEngagementMixin],
  props: {
    loading: {
      type: Object,
      required: true
    },
    keywords: {
      type: Array,
      required: true
    },
    maxValueY: {
      type: Number,
      required: true
    },
    chart: {
      type: Object,
      required: true
    },
    selectedReportType: {
      type: Number,
      required: true,
      validator: val => Object.values(PERIODIC_REPORT_TYPE).includes(val)
    }
  },

  computed: {
    chartHeight() {
      const minHeight = 500;
      const calculatedHeight = Math.floor(window.innerHeight - 355);
      return calculatedHeight < minHeight ? minHeight : calculatedHeight;
    }
  },

  mounted() {
    this.mixin__setGtmEngagementTimeouts();
  },

  methods: {
    setLoading(value) {
      this.$emit("setLoading", "chart", value);
    }
  }
};
</script>

.<style lang="scss" scoped>
.no-keywords {
  @include noData(650px);

  &__description {
    @include font-size(22px);
    text-align: center;
    margin: $spacing * 5 0 $spacing * 3;
    white-space: pre-line;
  }
}

.no-data {
  @include noData(500px);
}

.relative {
  position: relative;
}
</style>
